export interface Point2D {
  x: number;
  y: number;
}

const orientation = (p: Point2D, q: Point2D, r: Point2D): number => {
  const value = (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
  if (value === 0) return 0;
  return value > 0 ? 1 : 2;
};

const onSegment = (p: Point2D, q: Point2D, r: Point2D): boolean =>
  q.x <= Math.max(p.x, r.x) &&
  q.x >= Math.min(p.x, r.x) &&
  q.y <= Math.max(p.y, r.y) &&
  q.y >= Math.min(p.y, r.y);

export const doSegmentsIntersect = (
  a1: Point2D,
  a2: Point2D,
  b1: Point2D,
  b2: Point2D
): boolean => {
  const o1 = orientation(a1, a2, b1);
  const o2 = orientation(a1, a2, b2);
  const o3 = orientation(b1, b2, a1);
  const o4 = orientation(b1, b2, a2);

  if (o1 !== o2 && o3 !== o4) return true;

  if (o1 === 0 && onSegment(a1, b1, a2)) return true;
  if (o2 === 0 && onSegment(a1, b2, a2)) return true;
  if (o3 === 0 && onSegment(b1, a1, b2)) return true;
  if (o4 === 0 && onSegment(b1, a2, b2)) return true;

  return false;
};

export const distanceBetween = (a: Point2D, b: Point2D): number =>
  Math.sqrt((a.x - b.x) ** 2 + (a.y - b.y) ** 2);
